/**
 * <Internals> — show this only when an admin has turned internals on.
 *
 * For bespoke blocks that are not worth extracting into a component of their
 * own: a spend chip built inline in a header, a raw-JSON escape hatch, a stall
 * detector. Shared components (StageModelsWidget, ContextUsageChip,
 * AgentModelChip, AgentErrorBanner) gate themselves instead, so their call sites
 * never have to remember.
 *
 * Renders a fragment, so it never disturbs the flex row it sits in.
 */
import { ReactNode } from 'react';
import { useShowInternals } from '../../contexts/InternalsContext';

export default function Internals({ children }: { children: ReactNode }) {
  return useShowInternals() ? <>{children}</> : null;
}
